import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

/**
 *
 * Display a basic chip for Field content,
 * with field name as text and icon matching field displayType
 *
 */
import type { FieldSearchResultDto, LightSchemaFieldDto } from '@/api';
import SChipBasic, { type SChipSize } from '@/components/SChipBasic.vue';
import { getFieldIcon } from '@/utils/iconMappings';
import type { SiffletColors } from '@/plugins/theme';

export interface DatasetFieldChipProps {
  name?: string;
  type?: FieldSearchResultDto.typeCategory | LightSchemaFieldDto.typeCategory | null;
  color?: SiffletColors;
  size?: SChipSize
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DatasetFieldChip',
  props: {
  name: { default: '' },
  type: null,
  color: { default: 'iconNeutral' },
  size: null
},
  setup(__props) {

const props = __props;

const icon = _computed(() => getFieldIcon(props.type || 'UNKNOWN'));

return { __sfc: true,props, icon, _computed, SChipBasic, getFieldIcon }
}

})